import React ,{useState}from 'react';
import Fade from 'react-reveal/Fade';
import Text from '../../../../common/src/components/Text';
import Image from '../../../../common/src/components/Image';
import Button from '../../../../common/src/components/Button';
import BannerWrapper, {
  CustomerWrapper,
  ImageWrapper,
} from './banner.style';
import { client } from '../../../../common/src/data/AppModern';
import circleBorder from '../../../../common/src/assets/image/appModern/shape.svg';
import axios from 'axios'
import ButtonStyle from '../../../../common/src/components/Button/button.style';




const Banner = () => {
  const [Name,setName]=useState("")
const [Email,setEmail]=useState("")
const [Phone, setPhone]=useState("")
const [Message, setMessage]=useState("")

const[OpenForm,setOpenForm]=useState(0)
const [ShowForm,setShowForm]=useState(false)




const handleChange=(e)=>{
 
  switch(e.target.name){
case ("name"):
setName(e.target.value)  

break

case ("email"):
setEmail(e.target.value)  

break

case ("phone"):
setPhone(e.target.value)  

break

case ("message"):
setMessage(e.target.value)  

break




  }
}
 
const form=( <form dir="rtl" style={{
  color:"white",
  maxWidth: '500px',
}}>
   <fieldset>
   <legend style={{color:"white"}}>קורסים והתמקצעיות בפיתוח ותוכנה</legend>
   <center>

    שם מלא: <br/>
    <input  type="text" name="name"  value={Name} onChange={handleChange}/>
<br/>
    <br/>אימייל:<br/>
    <input  type="text" name="email"  value={Email} onChange={handleChange} />
<br/>
    <br/> טלפון:<br/>
    <input  type="text" name="phone"  value={Phone} onChange={handleChange} />

    <h2>במה נוכל לעזור?</h2>
    <textarea 
   rows="4" cols="30"
    name="message"  value={Message} onChange={handleChange}
    />
<br/>
<Button  title="שלח"  onClick={()=>{
if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(Email)))
alert("האימייל לא תקין- נא הכנס אימייל תקין!")
else
{
  
  axios({
method:"post",
url:" https://us-central1-sender-4330e.cloudfunctions.net/app/send_email_client",
data:{to:"omershiran@gmail.com",from:"omershiran@gmail.com",subject:"הודעה חדשה באתר מוטו בנושא טופס קורסים והתמקצעיות בפיתוח ותוכנה:  ",text:(Name+"  "+Email+"  "+Phone+"  "+Message)}
}).then((v)=>{
  if(v.data===1001){setOpenForm(1)}
else{
  
  setOpenForm(2)}
}).
  catch(e=>{ 
    
    setOpenForm(2)})
    setOpenForm(3) 
}}}/></center>
</fieldset>
</form>)
const AfterProperDelivery=(<h2 style={{color:"white"}}>ההודעה נשלחה בהצלחה</h2>)
const AfterUnProperDelivery=(<h2 style={{color:"white"}}>תקלה במשלוח ההודעה, ההודעה לא נשלחה,<br/> אנא נסה שנית במועד מאוחר יותר</h2>)
const DirectMessageAfterSending=(<h2 style={{color:"white"}}>ההודעה נשלחת אנא המתן...</h2>)
let formContent=(OpenForm===0)?form:(OpenForm===1)?AfterProperDelivery:(OpenForm===3)?DirectMessageAfterSending:AfterUnProperDelivery

const FormContainer=(<div><h2 style={{color:"white"}}>קורסים והתמקצעיות בפיתוח ותוכנה</h2>
<center>
<ButtonStyle className="trail"  onClick={()=>{setShowForm(!ShowForm)}}>
 מעוניין? - תשאיר פרטים ואנחנו ניצור עימך קשר- לחץ כאן
</ButtonStyle></center>
{ShowForm&&formContent}</div>)

  return (
    <BannerWrapper id="home" dir="rtl" >
       
          <Fade up delay={100}>
            <h2 style={{color:"white"}}>חדש – תשלום ב DCP CASH</h2>
            <h1 style={{color:"white"}}>מהיום ניתן לשלם עבור שרותי הפיתוח שלנו, במוטו ישראל, גם במטבע הדיגיטלי DCP CASH </h1>
            
            <div style={{clear: "both", dir:"ltr"}}>
    
</div>
<br/>

          </Fade>
          <Fade up delay={200}>
          {/* <h2 style={{color:"white"}}>
            <Text dir='rtl'
              content="פתרונות מתקדמים במחשבים, פיתוח מערכות, אפליקציות לניידים ואתרים."
            /></h2> */}
            {/* {FormContainer} */}
<h4 style={{color:"white"}}>
את התשלום יש להעביר לארנק   d970c3ba-8779-4c64-a5d6-555fef6e41ec <br/>
אין להגדיר סיסמת גבייה למפתח<br/>
יש לשלוח את מפתח הגבייה לאימייל  xxx@motto.co.il        <br/>
יש לאמת טלפונית את קבלת התשלום!        <br/>
אנו ממליצים להשתמש בארנקים של DCP-online-wallet        <br/>
בקישור:<a href={"https://www.wallet.site.democraticcooperative.cash/"} style={{color:"#A8DDFE"}}> https://www.wallet.site.democraticcooperative.cash/    </a>    <br/>
(מאובטח, קל לשימוש וללא עמלות)        <br/>
אם אתם משתמשים בארנק זה, נשמח שתשלחו לנו גם הודעה דרך הארנק, לאחר ביצוע העברה, למשתמש  omer-s        <br/>
שים לב! אנחנו משתדלים שהערך-שעה המוגדר במטבע דיגיטלי, לא יהיה גבוה מתשלום בכסף רגיל, עם זה, בגלל התנודתיות הגבוהה של המטבע והעלייה המשתנה בערכו, לא תמיד הדבר יוצא לפועל,        <br/>
בכל מקרה שכר השעה ב DCP CASH  מוגדר לפי זמן התשלום, ואין לנו כל אחריות ביחסי הערכים בינו לבין ערכי מטבעות אחרים        <br/>
<br/>
בכל שאלה ניתן לפנות אלינו         <br/>
באימייל: xxx@motto.co.il        <br/>
או        <br/>
בטלפון: 0524635325        <br/>
<br/>
נשמח לתת לכם שירות אדיב, פיתוח מקצועי ומהיר        <br/>

</h4>
          </Fade>
          
          

      <CustomerWrapper>
        <Text content="מהגלריה שלנו:" />
        <ImageWrapper>
         {client.map(item => (
            <a href={item.link} target="blank">
            <Image
              key={`client-key${item.id}`}
              src={item.image}
              alt={item.title}
            /></a>
          ))}
           </ImageWrapper>
      </CustomerWrapper>
      
      
      <img
        className="bannerBottomShape"
        src={circleBorder}
        alt="Bottom Circle"
      />
    </BannerWrapper>
  );
};

export default Banner;
